module.exports = __webpack_public_path__ + "static/media/shape2_0.a328c475.obj";